/**
 * Represents a block in the flow.
 */
export class State {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
